import React, { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import SliderCard from '../SliderCard';
import Autocomplete from '../Autocomplete';

const useStyles = makeStyles(() => ({
  sliderWrapper: {
    width: '50%',
  },
}));

export const SliderCardAutocomplete = ({
  options = [],
  onChange,
  value,
  groupBy,
  sliderTitle,
  inputLabel,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <SliderCard title={sliderTitle}>
      <Box className={classes.sliderWrapper}>
        <Autocomplete
          onChange={onChange}
          value={value}
          label={inputLabel}
          variant="outlined"
          options={options}
          groupBy={groupBy}
          popperProps={{ placement: 'bottom-start' }}
          dataTestId={inputLabel}
          disabled={disabled}
        />
      </Box>
    </SliderCard>
  );
};

export default memo(SliderCardAutocomplete);
